var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg044Instagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_044-instagram",
    "data-name": "044-instagram",
    transform: "translate(0.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67386",
    "data-name": "Group 67386",
    transform: "translate(-0.005 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67385",
    "data-name": "Group 67385",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80453",
    "data-name": "Path 80453",
    d: "M130.873,124.544a6.158,6.158,0,1,0,6.158,6.157A6.157,6.157,0,0,0,130.873,124.544Zm0,10.155a4,4,0,1,1,4-4A4,4,0,0,1,130.873,134.7Z",
    transform: "translate(-118.869 -118.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80454",
    "data-name": "Path 80454",
    d: "M16.943.088c-2.208-.1-7.677-.1-9.887,0A7.172,7.172,0,0,0,2.02,2.029C-.288,4.337.007,7.447.007,12.008c0,4.668-.26,7.706,2.013,9.979C4.337,24.3,7.492,24,12,24c4.624,0,6.22,0,7.855-.63,2.223-.863,3.9-2.85,4.065-6.419.1-2.209.1-7.677,0-9.887C23.721,2.851,21.46.3,16.943.088ZM20.438,20.46c-1.513,1.513-3.612,1.378-8.468,1.378-5,0-7,.074-8.468-1.393-1.685-1.677-1.38-4.37-1.38-8.453,0-5.525-.567-9.5,4.978-9.788,1.274-.045,1.649-.06,4.856-.06l.045.03c5.329,0,9.51-.558,9.761,4.986.057,1.265.07,1.645.07,4.847C21.831,16.949,21.925,18.966,20.438,20.46Z",
    transform: "translate(0.005 -0.013)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 1.439,
    cy: 1.439,
    r: 1.439,
    transform: "translate(16.967 4.155)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg044Instagram);
export default __webpack_public_path__ + "static/media/044-instagram.879b54a90aa95804aa6312353e7a7440.svg";
export { ForwardRef as ReactComponent };